export interface IApiKeyHolder {
  getApiKey(): string;
  setApiKey(apiKey: string): void;
}

export class ApiKeyHolder {
  private apiKey = "";

  public getApiKey(): string {
    return this.apiKey;
  }

  public setApiKey(apiKey: string): void {
    this.apiKey = apiKey;
  }
}

const defaultApiKeyHolder = new ApiKeyHolder();
export { defaultApiKeyHolder as apiKeyHolder };
